import React, { Component } from "react";
import { HiPlus } from "react-icons/hi";
import { Link } from "react-router-dom";
import Empty from "../../../base/features/blocks/Empty";
import SimpleHeader from "../../../base/features/blocks/SimpleHeader";
import Spinner from "../../../base/features/micro/Spinner";
import Image from "../../../base/features/micro/Image";
import { managersList } from "./services";

class ShopManagers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
      admins: null,
    };
  }
  componentDidMount() {
    this.getAdmins();
  }
  getAdmins() {
    managersList(this.state.shopUid).then((items) => {
      items && this.setState({ admins: items.results });
    });
  }
  render() {
    return (
      <div className="container-fluid">
        <div
          dir="ltr"
          className="position-fixed"
          style={{ bottom: "20px", left: "20px" }}
        >
          <Link to={`/dashboard/${this.state.shopUid}/managers/add`}>
            <div
              className="rounded-circle row mx-0 nav-bottom-grad"
              style={{
                height: "65px",
                width: "65px",
              }}
            >
              <div className="col align-self-center text-center px-0">
                <HiPlus size="38" className="text-white" />
              </div>
            </div>
          </Link>
        </div>
        <SimpleHeader text={"مدیران فروشگاه"} />
        <body style={{ marginTop: "80px" }}>
          {this.state.admins ? (
            this.state.admins.length === 0 ? (
              <Empty text="مدیر فروشگاهی ثبت نشده" />
            ) : (
              this.state.admins.map((admin, a) => (
                <Link
                  to={`/dashboard/${this.state.shopUid}/managers/${admin.uid}`}
                >
                  <div className="row mx-0 my-4 py-2">
                    <div className="col-auto px-1">
                      <Image
                        imageHeight={"50"}
                        imageWidth={"50"}
                        extraClassName={"p-0 img-contain"}
                        imgClassName={"rounded-circle img-cover"}
                        isProfile={true}
                        imageUri={admin.user.image && admin.user.image}
                      />
                    </div>
                    <div className="col px-1">
                      <p className="mb-1 fw-bold">{admin.user.name}</p>
                      <p className="mb-0 fw-bold small text-secondary">
                        {admin.role}
                      </p>
                    </div>
                  </div>
                </Link>
              ))
            )
          ) : (
            <Spinner />
          )}
        </body>
      </div>
    );
  }
}

export default ShopManagers;
